import React from "react";
import Homepage from "./pages/homepage";

function App() {
  return (
    <div className="App">
      <span id="overnavbaringpice"></span>
      <Homepage />
    </div>
  );
}

export default App;
